import { normalize, schema } from 'normalizr';

export const entity = 'industries';
export const entitySchema = new schema.Entity(entity);
export const listNormalizer = (result) => normalize(result.industries, [entitySchema]);
